<template>
  <div>
    <ProgressBar active-step="Confirm" />
    <PageHeading :default-heading="pd_content.page_header" />
    <form @submit.prevent>
      <div>
        <div class="pvd-container container-divider">
          <h2 class="pvd-heading-L">
            {{ pd_content.terms_section_header }}
          </h2>
          <DescriptionListComponent
            :pdf-url="pd_content.terms_section.pdf_1_url"
            :pdf-label="pd_content.terms_section.pdf_1_label"
            :pdf-description="pd_content.terms_section.pdf_1_description"
            :footer="pd_content.terms_section_footer"
          />
        </div>
        <div class="pvd-container container-divider">
          <h2
            id="agreement"
            class="pvd-heading-L"
          >
            {{ pd_content.edelivery_label }}
          </h2>
          <ToggleComponent
            :id-prefix="idPrefix"
            :toggle-value.sync="pu_receiveAccountDocElectronically"
            :yes-label="pd_content.yes_toggle_text"
            :no-label="pd_content.no_toggle_text"
            :validation-rules="pd_content.electronic_delivery_validation_rules"
            :label="''"
            :track-events="true"
            :message="pd_content.electronic_delivery_validation_text"
          />
        </div>
        <!-- Required only for iStock -->
        <div
          v-if="usCitizen"
          class="pvd-container container-divider"
        >
          <h2 class="form-heading-2">
            {{ pd_content.w9_certification_header }}
          </h2>
          <p class="text-italic">
            {{ pd_content.w9_certification_paragraph }}
          </p>
          <VueShowdown
            :extensions="[formatMarkdown]"
            :markdown="pd_content.w9_certification_list"
          />
          <InputConfirm
            :label="pd_content.w9_certification_confirm"
            :label-class="'text-italic'"
            :id-prefix="idPrefix"
            :tax-holding.sync="pu_taxWithHolding"
            :track-events="true"
          />
        </div>
        <div
          v-if="pd_content.istock_participant_agreement_text"
          class="pvd-container p-xxsmall-top"
        >
          <p class="m-xxsmall-top">
            {{ pd_content.istock_participant_agreement_text }}
          </p>
        </div>
        <div
          v-if="usCitizen"
          class="pvd-container p-xxsmall-top"
        >
          <p class="text-bold text-italic m-xxsmall-top">
            {{ pd_content.w9_certification_consent_notice }}
          </p>
        </div>
      </div>
      <NavigationComponent />
    </form>
  </div>
</template>

<script>
import NavigationComponent from '../components/NavigationComponent.vue';
import PageHeading from '../components/PageHeading.vue';
import ProgressBar from '../components/ProgressBar.vue';
import DescriptionListComponent from '../components/DescriptionListComponent.vue';
import ToggleComponent from '../components/ToggleComponent.vue';
import InputConfirm from '../components/InputConfirm.vue';
import dataHelper from '../mixins/dataHelper';
import measurement from '../mixins/measurement';
import utility from '../mixins/utility';

export default {
  name: 'AgreeToTerms',
  components: {
    NavigationComponent,
    PageHeading,
    ProgressBar,
    DescriptionListComponent,
    ToggleComponent,
    InputConfirm,
  },
  mixins: [dataHelper, measurement, utility],
  data() {
    return {
      idPrefix: 'agreement',
      backButtonAttempt: false,
    };
  },
  computed: {
    name() {
      return `${this.idPrefix}ToggleStacked`;
    },
    usCitizen() {
      return this.pu_usCitizen === 'Yes';
    },
  },
  mounted() {
    this.track(this.cs_stateName, 'pageview');
    document.title = this.setTitle(this.pd_content.page_header);
    this.configureBackButtonFunctionality(() => this.showBackWarning(
      this.pd_content.back_button_disabled_warning,
    ));
  },
};
</script>

<style scoped>
</style>
